/*
* CA Disclosure page 1
*/

import * as React from 'react';
import * as _ from 'lodash';
import moment from 'moment';

import * as ReportComponents from '../report-components';
import { Formatters } from '../../../common/formatters';
import ApiEndpoints from '../../../config/apiendpoints';

export const Render = ({ reportData, tableSpecial, tableAdditional, ...rest }) => {
    const {
        currentOrder,
        currentOrderChart,
        currentOrderUsers,
        branding,
        association,
        reportBeginYearSummary,
        reportPeriodStartDate,
        reportPeriodEndDate,
        reportPeriodFYEDate,
        reportParameters,
    } = reportData;

    const {
        // fiscalYearPeriod,
        // fiscalYearPeriod_reportCurrent,
        // approvedAssessment,
        // reserveBalancesSufficient,
        estimatedReserveAmountRequired,
        // projectedFundBalance,
        projectedFundPercent,

        // refactored reportData vars
        reportApprovedAssessment,
        reportApprovedSpecialAssessment,
        reportLastReservePreparedDate,
        reportDisclosureForFYEPeriodDate,
        reportReserveBalancesSufficient,
        reportProjectedFundBalanceAtFYE,
        // reportApprovedReserveContribution,
        // reportAnnualIncreases,
        // reportNumYears,
        // reportSecondaryIncrease,
        reportExhibitText,

        // analysisFullyFundedBalance,
        // analysisProjectedFundBalance,
        analysisProjectedPercentFundBalance,
        // analysisFundingDeficiencyPerUnit,
        // analysisNumberOfUnits,
        // analysisInflationRate,
        // analysisAfterTaxInterestRate,
        // analysisRecommendedMRC,
        // analysisRecommendedValues,
        // analysisPreparedForFYE,
    } = reportParameters;

    // const reportEndDateShort = ReportComponents.shortDate(moment(reportPeriodEndDate).toDate());
    const reportEndDateShort = ReportComponents.shortDate(moment(reportDisclosureForFYEPeriodDate).toDate());

    const reportFYPCMoment = moment(reportDisclosureForFYEPeriodDate).subtract(1, 'years');
    const reportFYPCYear = moment(reportFYPCMoment).year();
    const fiscalYearPeriodReportCurrent = `${reportFYPCYear}`;

    // console.log('disclosure-page-1 data', {
    //     reportData,
    //     reportEndDateShort,
    //     reportPeriodEndDate,
    //     reportLastReservePreparedDate,
    //     reportDisclosureForFYEPeriodDate,
    //     reportFYPC_moment: reportFYPCMoment,
    //     reportFYPC_year: reportFYPCYear,
    //     fiscalYearPeriod_reportCurrent: fiscalYearPeriodReportCurrent,
    // });

    const buildTextUnderlined = (s: any) => (<span className="pdf-disclosure-page-1-section-text-na">{s}</span>);
    const NAText = 'N/A';
    const pageNA = buildTextUnderlined(NAText);
    const pageExhibitText = buildTextUnderlined((reportExhibitText) ? reportExhibitText : NAText);
    const pageNBSP = (<span>&nbsp;</span>);

    // TODO: FROM REPORTDATA/CLIENT WEB INPUT
    const tAssessmentsAdditionalHeadRow = (
        <tr>
            <th className="text-left">Date assessment will be due</th>
            <th className="text-left">Amount per ownership interest per month or year (If assessments are variable, see note immediately below)</th>
            <th className="text-left">Purpose of the Assessment</th>
        </tr>
    );

    const buildAssessmentTableRows = (data: any[], sectionName: string = 'assessments', tableName: string = 'tbl') => {
        let rows: any = _(data)
            .map((item: any, ind: number, arr: any[]) => {
                let res = _.stubArray();

                const rowKey = Formatters.getStr(item, 'rowKey');

                res.push(
                    <tr key={ReportComponents.getRowKey(rowKey, sectionName, tableName)}>
                        <td className="text-center">{item.dueDate}</td>
                        <td className="text-center">{item.amount}</td>
                        <td className="text-center">{item.purpose}</td>
                    </tr>
                );

                return res;
            })
            .value();

        return rows;
    };

    const tAssessmentsAdditionalBodyRows = buildAssessmentTableRows(
        [
            { rowKey: 1, dueDate: NAText, amount: NAText, purpose: NAText },
            { rowKey: 2, dueDate: pageNBSP, amount: pageNBSP, purpose: pageNBSP },
            { rowKey: 3, dueDate: 'Total:', amount: pageNBSP, purpose: pageNBSP }
        ],
        'disclosure-table-assessments',
        'tbl-assessments'
    );

    // TODO: FROM REPORTDATA/CLIENT WEB INPUT
    const resBalSufficientYes = (reportReserveBalancesSufficient) ? buildTextUnderlined('X') : buildTextUnderlined(pageNBSP);
    const resBalSufficientNo = (!reportReserveBalancesSufficient) ? buildTextUnderlined('X') : buildTextUnderlined(pageNBSP);

    // TODO: FROM REPORTDATA/CLIENT WEB INPUT
    const tAssessmentsNecessaryHeadRow = (
        <tr>
            <th className="text-center">Approximate date assessment will be due</th>
            <th className="text-center">Amount per ownership interest per month or year</th>
        </tr>
    );

    const buildAssessmentNecessaryTableRows = (data: any[], sectionName: string = 'assessments-necessary', tableName: string = 'tbl') => {
        let rows: any = _(data)
            .map((item: any, ind: number, arr: any[]) => {
                let res = _.stubArray();

                const rowKey = Formatters.getStr(item, 'rowKey');

                res.push(
                    <tr key={ReportComponents.getRowKey(rowKey, sectionName, tableName)}>
                        <td className="text-left">{item.dueDate}</td>
                        <td className="text-left">{item.amount}</td>
                    </tr>
                );

                return res;
            })
            .value();

        return rows;
    };

    const tAssessmentsNecessaryBodyRows = buildAssessmentNecessaryTableRows(
        [
            { rowKey: 1, dueDate: NAText, amount: NAText },
            { rowKey: 2, dueDate: pageNBSP, amount: pageNBSP },
            { rowKey: 3, dueDate: pageNBSP, amount: 'Total:' }
        ],
        'disclosure-table-assessments-necessary',
        'tbl-assessments-necessary'
    );

    // SECTION 6
    const lastReservePreparedByCompany = Formatters.getStr(currentOrder, 'company.name');

    return (
        <ReportComponents.ReportPage className="pdf-disclosure-page-1" reportData={reportData}>
            { /* Title Section */}
            <div className="pdf-disclosure-page-1-title-container">
                <div className="pdf-disclosure-page-1-title">Assessment and Reserve Funding Disclosure Summary</div>
                <div className="pdf-disclosure-page-1-title">For the Fiscal Year Ending {reportEndDateShort}</div>
                <div className="pdf-disclosure-page-1-subtitle">California Civil Code Section 5570</div>
                <div className="pdf-disclosure-page-1-title-association">{Formatters.getStr(association, 'name')}</div>
            </div>

            { /* Bullet 1 Section */}
            <div className="pdf-disclosure-page-1-section-container">
                <div className="pdf-disclosure-page-1-section-text">
                    (1) The assessment per ownership interest is {reportApprovedAssessment} per month. Note: If assessments vary by the size or type
                    of ownership interest, the assessment applicable to this ownership interest may be found on page {pageExhibitText}
                    of the attached summary.
                </div>
            </div>

            { /* Bullet 2 Section */}
            <div className="pdf-disclosure-page-1-section-container">
                <div className="pdf-disclosure-page-1-section-text">
                    (2) Additional regular or special assessments that have already been scheduled to be imposed or charged, regardless of the purpose,
                    if they have been approved by the board and/or members:
                </div>

                <div className="pdf-disclosure-page-1-section-table">
                    {tableSpecial}
                    { /* <ReportComponents.ReportTable
                        theadRow={tAssessmentsAdditionalHeadRow}
                        tbodyRows={tAssessmentsAdditionalBodyRows}
                        className="pdf-disclosure-page-1-table-assessments"
                    /> */}
                </div>

                <div className="pdf-disclosure-page-1-section-text">
                    Note: If assessments vary by the size or type of ownership interest, the assessment applicable to this ownership interest may be
                    found on page {pageExhibitText} of the attached report.
                </div>
            </div>

            { /* Bullet 3 Section */}
            <div className="pdf-disclosure-page-1-section-container">
                <div className="pdf-disclosure-page-1-section-text">
                    (3) Based upon the most recent reserve study and other information available to the board of directors, will currently
                    projected reserve account balances be sufficient at the end of each year to meet the association's obligation for repair
                    and/or replacement of major components during the next 30 years? Yes {resBalSufficientYes} No {resBalSufficientNo}
                </div>
            </div>

            { /* Bullet 4 Section */}
            <div className="pdf-disclosure-page-1-section-container">
                <div className="pdf-disclosure-page-1-section-text">
                    (4) If the answer to (3) is no, what additional assessments or other contributions to reserves would be necessary to ensure that
                    sufficient reserve funds will be available each year during the next 30 years that have not yet been approved by the board or the members?
                </div>

                <div className="pdf-disclosure-page-1-section-table">
                    {tableAdditional}
                    { /* <ReportComponents.ReportTable
                        theadRow={tAssessmentsNecessaryHeadRow}
                        tbodyRows={tAssessmentsNecessaryBodyRows}
                        className="pdf-disclosure-page-1-table-assessments-necessary"
                /> */}
                </div>
            </div>

            { /* Bullet 5 Section */}
            <div className="pdf-disclosure-page-1-section-container">
                <div className="pdf-disclosure-page-1-section-text">
                    (5) All major components are included in the reserve study and are included in its calculations.
                </div>
            </div>

            { /* Bullet 6 Section */}
            <div className="pdf-disclosure-page-1-section-container">
                <div className="pdf-disclosure-page-1-section-text">
                    (6) Based on the method of calculation in paragraph (4) of subdivision (b) of Section 5570, the estimated amount required in the reserve
                    fund at the end of the current fiscal year (FY {fiscalYearPeriodReportCurrent}) is <ReportComponents.Currency value={estimatedReserveAmountRequired} decimals={0} />, based in whole
                    or in part on the last reserve study or update prepared by {lastReservePreparedByCompany} as of {(reportLastReservePreparedDate) ? ReportComponents.monthDate(reportLastReservePreparedDate) : (<strong>INVALID DATE</strong>)}.
                    The projected reserve fund cash balance at the end of the current fiscal year (FY {fiscalYearPeriodReportCurrent}) is <ReportComponents.Currency value={reportProjectedFundBalanceAtFYE} decimals={0} />,
                    resulting in reserves being <ReportComponents.Percentage value={analysisProjectedPercentFundBalance /* projectedFundPercent */} decimals={0} /> funded at this date. If an alternate,
                    but generally accepted, method of calculation is also used, the required reserve amount is ${pageNA}. (See attached explanation if applicable)
                </div>
            </div>
        </ReportComponents.ReportPage>
    );
};



// WEBPACK FOOTER //
// ./src/report/pdf/pages/disclosure-page-1.tsx